<template>
  <div class="container act-wrap">
    <!-- 背景图 -->
    <InviteActBgBox/>

    <!-- 头部 -->
    <InviteHeader
      :invite-person-num="invitePersonNum"
      :copy-status="copyStatus"
      :share-url="shareUrl"
      :all-num="allNum"
      @showInviteDialog="showInviteDialog"
      @updateCopyStatus="updateCopyStatus"
      @updateUserMaterialDownload="updateUserMaterialDownload"
    />

    <!-- 记录 -->
    <InviteRecord :all-record-data="allRecordData"/>

    <!-- 邀请奖励 -->
    <InviteActAward/>

    <!-- 规则 -->
    <InviteActRule/>

    <InviteRecordDialog
      ref="InviteRecordDialog"
      :invite-list="selfRecordData"/>

    <HomeBtn/>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import {
  InviteRecordDialog,
  InviteActAward,
  HomeBtn,
  InviteActBgBox,
  InviteRecord,
  InviteActRule,
  InviteHeader
} from '@/components/invite';
import Cookies from 'js-cookie'
import {ENV_BASE_URL, INVITE_FRIENDS} from "@/constant/PATH";
import {mapGetters} from "vuex";
import {getInviterRecord} from "@/api/invite-friends";

export default {
  layout: "act",
  head() {
    return {
      title: '好友助力领福利_免费下载机会等你来拿_潮国创意'
    }
  },
  data() {
    return {
      copyStatus: 0,
      shareUrl: '生成中...',
      actRecords: [],
      isCopy: false,
      invitePersonNum: 0,
      actInviteBarStyle: '',
      ENV_BASE_URL,

      isShowCopyLink: false,
      entry: this.$route.params.entry || this.$route.query.entry || 1,
      // user_uniq_id : Cookies.get('user_uniq_id')
      INVITE_FRIENDS,

      selfRecordData: [],
      allRecordData: [],
      allNum: 0,
    }
  },
  components: {
    InviteRecordDialog,
    InviteActRule,
    InviteActAward,
    InviteActBgBox,
    InviteRecord,
    InviteHeader,
    HomeBtn
  },
  computed: {
    ...mapGetters('user', ['avatar']),
    user_uniq_id() {
      return this.$store.state.user.uniq_id
    }
  },
  watch: {
    user_uniq_id(newVal, oldVal) {
      if (newVal != null || newVal != undefined) {
        this.copyStatus = 0;
        this.shareUrl = INVITE_FRIENDS + '/' + newVal;
        this.getRecord('self');
      }
    }
  },

  created() {

  },
  mounted() {
    this.getRecord('all');
    /* 获取当前用户uni_id 并生成链接 */
    const user_uniq_id = Cookies.get('user_uniq_id')
    if (user_uniq_id) {
      const _user_uniq_id = user_uniq_id.replace(/"/g, '');
      this.shareUrl = `${INVITE_FRIENDS}/${_user_uniq_id}`
      this.getRecord('self');
    } else {
      /* 兼容用户直接进入活动页 */
      this.copyStatus = 2;
      this.shareUrl = '登录后查看链接'
    }

  },
  methods: {

    covertArr(data) {
      let arr = [];
      for (let i = 0; i < data.length; i += 2) {
        arr.push(data.slice(i, i + 2));
      }
      return arr;
    },

    async getRecord(type) {

      if (type === 'all') {
        let all = await getInviterRecord({type: 'all', entry: this.entry})
        this.allRecordData = this.covertArr(all.data.data);
        this.allNum = all.data.allNUm;
      } else {
        let self = await getInviterRecord({type: 'self'})
        let tempNum = self.data.allNUm > 100 ? 100 : self.data.allNUm;  // 前端做出限制条件，最大数量为5;
        this.invitePersonNum = parseInt(tempNum);
        this.selfRecordData = self.data.data;
      }

    },

    updateUserMaterialDownload(){
      this.getRecord('all');
      this.getRecord();
    },

    async showInviteDialog() {
      /* 判断是否登录 */
      let auth_id = Cookies.get('auth_id');
      if (!auth_id) {
        // this.$myNotify.show('请先登录')
        this.$store.commit('user/SET_IS_SHOW_LOGIN', true);
        return false;
      }
      let self = await getInviterRecord({type: 'self'})
      if (self.data.data.length === 0) {
        this.$myNotify.show('暂无邀请记录,请邀请后查看')
        return false;
      }
      this.$refs.InviteRecordDialog.isShow = true;
    },
    updateCopyStatus(val){
      this.copyStatus = val;
    }
  }
}
</script>

<style lang="scss" scoped>
.act-wrap {
  position: relative;
  overflow: scroll;
  width: 100%;

}
</style>
